import { init, setUser, addEventProcessor, setContext } from '@sentry/react'
import { CaptureConsole } from '@sentry/integrations'
import { Dispatch } from 'redux'
import { Data as User } from './types/me'
import { isMac } from './office/client'

init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_ENV,
  // Limit number of recorded transactions (0.2 means ~20% of transactions will get recorded and sent)
  sampleRate: 0.26,
  integrations: [
    // capture handled errors that are logged in the console but not thrown
    new CaptureConsole({
      levels: ['error'],
    }),
  ],
})

export {
  captureException,
  setUser,
  addEventProcessor,
  addBreadcrumb,
  ErrorBoundary,
  withScope,
  setContext,
} from '@sentry/react'

export const watchSentryUser = () => (next: Dispatch) => (action: { type: string; user: User }) => {
  if (action !== undefined && action.type === 'ASSIGN_USER') {
    setUser({
      id: String(action.user.id),
      email: action.user.email,
      username: action.user.name,
      user_guid: action.user.guid,
      team_id: action.user.team.id,
      permitted_localities: action.user.permitted_localities,
    })

    setContext('user_info', {
      user_guid: action.user.guid,
      team_id: action.user.team.id,
      permitted_localities: action.user.permitted_localities,
    })

    addEventProcessor(function(event) {
      if (!action.user.permitted_localities.includes('us')) {
        return null
      }

      return event
    })
  }
  return next(action)
}

export const setHostData = (requirementSet: string) => {
  setContext('environment', {
    emailAddress: Office.context.mailbox.userProfile.emailAddress,
    hostName: Office.context.mailbox.diagnostics.hostName,
    hostVersion: Office.context.mailbox.diagnostics.hostVersion,
    ewsUrl: Office.context.mailbox.ewsUrl,
    requirementSet: requirementSet,
    isMac: isMac(),
  })
}
